// <head> metadata for SolutionsAgenticAiPlatformPage (https://www.dbos.dev/solutions/agentic-ai-platform).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Durable Agentic AI Platform - Use it for Free',
    },
    {
      name: 'description',
      content:
        'Breakthrough serverless platform for Agentic AI. Build in Python. Gain Durability, Observability, Scalability by default. 50x more cost efficient than AWS Lambda.',
    },
    {
      property: 'og:title',
      content: 'Durable Agentic AI Platform - Use it for Free',
    },
    {
      property: 'og:description',
      content:
        'Breakthrough serverless platform for Agentic AI. Build in Python. Gain Durability, Observability, Scalability by default. 50x more cost efficient than AWS Lambda.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/6777ff5094ea07ccff1fce0a_DBOS-Agentic-AI-Platform.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Durable Agentic AI Platform - Use it for Free',
    },
    {
      name: 'twitter:description',
      content:
        'Breakthrough serverless platform for Agentic AI. Build in Python. Gain Durability, Observability, Scalability by default. 50x more cost efficient than AWS Lambda.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/6777ff5094ea07ccff1fce0a_DBOS-Agentic-AI-Platform.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/agentic-ai-platform',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
